import React from 'react';
// @ts-ignore
import styles from './InsuranceReportsListItem.module.scss';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import Text from '../../../../Components/Base/Text/Text';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import RemoveButton from '../../../../Components/Button/RemoveButton';
import { useDeleteInsuranceReportMutation } from '../../../../graphql/graphql';

interface Props {
	item: {
		id: string;
		createdAt: string;
		birthNumber: string;
		diagnosis: string;
		operation: {
			id: string;
			title: string;
		};
		count: number;
		points: number;
	};
	onDelete: () => void;
}

const InsuranceReportsListItem: React.FC<Props> = ({ item, onDelete }) => {
	const [deleteInsuranceReport] = useDeleteInsuranceReportMutation();

	const handleRemoveInsuranceReport = async () => {
		await deleteInsuranceReport({ id: item.id });
		onDelete();
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.date}>
				<FormattedMomentDate
					date={item.createdAt}
					format={DateFormat.DATE_TIME}
				/>
			</div>
			<div className={styles.content}>
				{item.diagnosis && (
					<div className={styles.item}>
						<Text
							tx='component.insuranceReportsListItem.diagnosis'
							firstUpper
							className={styles.title}
							colon
						/>
						<div className={styles.text}>{item.diagnosis}</div>
					</div>
				)}
				{item.operation.title && (
					<div className={styles.item}>
						<Text
							tx='component.insuranceReportsListItem.operation'
							firstUpper
							className={styles.title}
							colon
						/>
						<div className={styles.text}>{item.operation.title}</div>
					</div>
				)}
				{item.count && (
					<div className={styles.item}>
						<Text
							tx='component.insuranceReportsListItem.count'
							firstUpper
							className={styles.title}
							colon
						/>
						<div className={styles.text}>{item.count}</div>
					</div>
				)}
				{item.points && (
					<div className={styles.item}>
						<Text
							tx='component.insuranceReportsListItem.points'
							firstUpper
							className={styles.title}
							colon
						/>
						<div className={styles.text}>{item.points}</div>
					</div>
				)}
			</div>
			<div className={styles.controls}>
				<RemoveButton title='Smazat' onClick={handleRemoveInsuranceReport} />
			</div>
		</div>
	);
};

export default InsuranceReportsListItem;
